/*============================================================================
  Header section
==============================================================================*/
function is_touch_device() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
};

var header = {
    init: function(){
  
      var closeDropdown = function() {
        $('body').removeClass('is-active');
        $('.dropdown_link').removeClass('active_link');
        $('.dropdown_container').hide();
        $('.mobile_nav').find('div').removeClass('open');
      };
  
      var closeMiniCart = function() {
        $('body').removeClass('is-active');
        $('.dropdown_link').toggleClass('active_link');
        $('.cart_container').removeClass('active_link');
      };
  
      var openMiniCart = function($cart_container) {
        $('.mobile_nav div').removeClass('open');
        $('.dropdown_link').removeClass('active_link');
        $cart_container.addClass('active_link');
      };
  
      /* if ($('.promo_banner').length){
        var promo_banner = Cookies.get('promo_banner');
  
        if (promo_banner != 'dismiss') {
          $('body').addClass('promo_banner-show');
          $('.promo_banner').on('click', '.promo_banner-close', function(){
            $('body').removeClass('promo_banner-show');
            Cookies.set('promo_banner', 'dismiss', { expires: 30 });
          });
        }
      } */
  
      //offscreen check for menu
      $('.vertical-menu_submenu, .vertical-menu_sub-submenu').each(function() {
        if($(this).is(':off-right')) {
          $(this).addClass('vertical-menu--align-right');
        }
      });

      $(document).ready(function() {

  // Get current page URL
  const currentUrl = window.location.href;

  var discountMessage = `Don't forget to use code <strong style="color: black !important">THANKS1000</strong> at checkout for <strong style="color: black !important">$1325 OFF!</strong>`;

  // Check if the current URL matches either target
  if (currentUrl.includes("/in-stock-155-53-b-cup-lana-full-silicone-piper-doll")) {
    $("#checkoutmessage").html(discountMessage);
  } 
  else if (currentUrl.includes("/in-stock-130-43-d-cup-eirian-full-silicone-piper-doll-1")) {
    $("#checkoutmessage").html(discountMessage);
  }
});
  
      //Click anywhere outside of dropdown to close
      $('html').on('click', function(event) {
        if (!$(event.target).closest('.cart_container').length && $('.cart_content').is(':visible')) {
  
          closeMiniCart();
        }
  
        if (!$(event.target).closest('.dropdown_container').length && $('.dropdown').is(':visible')) {
  
          closeDropdown();
        }
  
      });
  
      //Only apply on larger screen sizes
      if ($(window).width() > 798) {
        if ($('.header').hasClass('header-fixed--true')){
          if (!$('.main_nav_wrapper').hasClass('sticky_nav')) {
            var sticky_nav = new Headhesive('.main_nav_wrapper', {
              offset: 700,
              throttle: 300,
              classes: {
                clone: 'sticky_nav',
                stick: 'sticky_nav--stick',
                unstick: 'sticky_nav--unstick'
              },
              onInit: function() {
                $(".sticky_nav .secondary_logo").css('display', 'none');
                $(".sticky_nav .primary_logo").css('display', 'block');
                $(".sticky_nav .icon-search").css('display', 'block');
                $(".sticky_nav .search_container").css('display', 'none');
                $(".sticky_nav .nav:last").prepend($(".header .cart_container").clone());
                if (shopify_global.menu_position == "inline"){
                  var sticky_nav_height = $(".sticky_nav").height() + 5;
                } else {
                  var sticky_nav_height = $(".sticky_nav .nav").height() + 5;
                }
                $(".sticky_nav .mini_cart").css("height", $(".sticky_nav").height() + 5);
                $(".sticky_nav .cart_content").css("top", $(".sticky_nav").height());
              },
              onUnstick: function() {
                $('.cart_container').removeClass('active_link');
              }
            });
          }
        } else {
          $('.header-fixed--true').removeClass('header-fixed--true');
          if ($('.main_nav_wrapper').length > 1) {
            $('.main_nav_wrapper').first().remove();
          }
        }
  
        if ($('img.primary_logo:visible')){
          $('.logo img', $(".feature_image .header")).attr('src', $('.logo img').data('src-home'));
        } else {
          $('.logo img').attr('src', $('.logo img').data('src'));
        }
      } else {
        if ($('#header').hasClass('mobile_nav-fixed--true')){
          $('body').addClass('mobile_nav-fixed--true');
        } else {
          $('body').addClass('mobile_nav-fixed--false');
        }
      }
  
      $('#header .cart_container').append($('.cart_content').clone());
  
      if ($(window).width() <= 798) {
  
        $('.dropdown_link').attr('data-no-instant', true);
  
        $('body').on('click', '.dropdown_link', function(e) {
          $('.nav a').removeClass('active_link');
  
          if ($('#header').is(':visible')) {
            var $dropdown = $(this).parents("#header").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]')
  
              if(!$(this).hasClass('mini_cart')) {
                $('.cart_container').removeClass('active_link');
              }
  
          } else {
  
            if($(this).hasClass("icon-search")) {
              window.location = $(this).attr("href");
              return false;
            }
  
            var $dropdown = $(this).parents(".main_nav").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]')
          }
  
          if ($dropdown.is(':visible') || $dropdown.attr('class') === undefined) {
            $dropdown.hide();
            $('body').removeClass('is-active');
          } else {
            $('.dropdown_container').hide();
            if(!$(this).hasClass('cart_container')) {
              $('.is-absolute').parent().removeClass('feature_image');
            }
            $dropdown.show();
            $('body').addClass('is-active');
            $('.mobile_nav').find('div').removeClass('open');
          }
  
          if ($dropdown.is(':visible')) {
            e.stopPropagation();
            return false;
          }
        });
  
        $('body').on("click", '.mobile_nav', function() {
          $(this).find('div').toggleClass('open');
        });
  
        //Toggle mini-cart with menu icon
        $(".mini_cart").on("click", function(e) {
          var $cart_container = $(this).parent();
          if($cart_container.hasClass('active_link')) {
            closeMiniCart();
          } else {
            //openMiniCart($cart_container);
            window.location.href='/cart';
          }
  
          if (is_touch_device() || $(window).width() <= 798) {
            e.preventDefault();
          }
        });
  
        $('.cart_content__continue-shopping').on('click', function(e){
          closeMiniCart();
        })
  
      } else {
  
        $(".nav a, .logo a").not(".cart_content a").on("mouseenter", function() {
          if(!$(this).hasClass("active_link")) {
            $('.dropdown_container').hide();
            $('.active_link').removeClass('active_link');
            $('.is-absolute').parent().addClass('feature_image');
          }
        });
  
        $('.main_nav, .top_bar, .cart_container').on("mouseleave", function() {
          $('.dropdown_container').hide();
          $('.active_link').removeClass('active_link');
          $('.is-absolute').parent().addClass('feature_image');
        });
  
        $('.dropdown_link, .dropdown_link--vertical').attr('data-click-count', 0);
  
        $('.dropdown_link').on('mouseover touchstart', function(e) {
          $('.dropdown_container').hide();
          var $dropdown = $(this).parents('.main_nav').find('[data-dropdown="' + $(this).data('dropdown-rel') + '"]');
          var clickCount = $(this).attr('data-click-count');
  
          $('.active_link').removeClass('active_link');
  
          if(!$(this).hasClass('active_link')) {
            $dropdown.show();
  
            if($(this).hasClass('mini_cart')) {
              //$(this).parent('.cart_container').addClass('active_link');
            } else {
              $(this).addClass('active_link');
              $('.is-absolute').parent().removeClass('feature_image');
            }
          }
  
          //Enable touch on parent link if on touch device and desktop menu is visible
          if(is_touch_device()){
            $('.dropdown_link').not(this).attr('data-click-count', 0);
            $('.dropdown_link').attr('data-no-instant', true);
  
            //capture touch event
            if (e.type == 'touchstart'){
              clickCount++;
              $(this).attr('data-click-count', clickCount);
  
              if (clickCount < 2){
                e.preventDefault();
                e.stopPropagation();
                return false;
              }
            }
          }
  
        });
  
        //Vertical menu enabled
        if ($('.dropdown_link--vertical').length){
          $('.dropdown_link--vertical, .vertical-menu_submenu').on('mouseover', function(e) {
            var $dropdown = $(this).parents('.main_nav').find('[data-dropdown="' + $(this).data('dropdown-rel') + '"]');
            var clickCount = $(this).attr('data-click-count');
  
            $('.active_link').removeClass('active_link');
            if(!$(this).hasClass('active_link')) {
              $(this).children('a').addClass('active_link');
              $('.is-absolute').parent().removeClass('feature_image');
            }
          });
  
          //Enable touch on parent link if on touch device and desktop menu is visible
          if(is_touch_device()){
            $('.dropdown_link--vertical').on('touchstart', function(e) {
              var $dropdownMegaMenu = $(this).parents('.main_nav').find('[data-dropdown="' + $(this).data('dropdown-rel') + '"]');
              var $dropdownVertical = $(this).next('.vertical-menu_submenu');
              var clickCount = $(this).attr('data-click-count');
  
              $('.dropdown_link--vertical').not(this).attr('data-click-count', 0);
              $('.dropdown_link--vertical').attr('data-no-instant', true);
              $('.dropdown_container').hide();
  
              $dropdownMegaMenu.show();
              $('.vertical-menu_submenu').removeClass('is-visible');
              $dropdownVertical.addClass('is-visible');
  
              //capture touch event
              if (e.type == 'touchstart'){
                clickCount++;
                $(this).attr('data-click-count', clickCount);
  
                if (clickCount < 2){
                  e.preventDefault();
                  e.stopPropagation();
                  return false;
                }
              }
            });
          }
        }
  
      }
  
    },
    removeDataAttributes: function(target){
      if($(target).length){
        var i,
            $target = $(target),
            attrName,
            dataAttrsToDelete = [],
            dataAttrs = $target.get(0).attributes,
            dataAttrsLen = dataAttrs.length;
  
        for (i=0; i<dataAttrsLen; i++) {
          if ( 'data-' === dataAttrs[i].name.substring(0,5) ) {
            dataAttrsToDelete.push(dataAttrs[i].name);
          }
        }
        $.each( dataAttrsToDelete, function( index, attrName ) {
          $target.removeAttr( attrName );
        })
      }
    },
    loadMegaMenu: function(){
  
      //Remove old mega-menus so that theme-editor works properly
      $('.sticky_nav .mega-menu').remove();
      $('.header .mega-menu').remove();
  
      //Clone the mega menu from section into sticky_nav
      $('.mega-menu-container .mega-menu')
        .clone()
        .appendTo('.sticky_nav .main_nav');
      //Remove theme-editor data-attributes
      header.removeDataAttributes('.sticky_nav .mega-menu.dropdown_container .dropdown_column');
  
      //Loop through mega-menus to add arrow to parent
      $('.mega-menu-container .mega-menu').each(function(index){
        var megaMenuValue = $(this).data("dropdown");
        $('[data-dropdown-rel="' + megaMenuValue + '"]')
          .find('span')
          .remove();
  
        $('[data-dropdown-rel="' + megaMenuValue + '"]')
          .not('.icon-search')
          .append(' <span class="icon-down-arrow"></span>')
          .addClass('mega-menu-parent')
          .addClass('dropdown_link')
          .removeClass('top_link');
  
        $('[data-dropdown="' + megaMenuValue + '"]').each(function(index){
          if (!$(this).hasClass('mega-menu')) {
            $(this).remove();
          }
        });
  
        $(this).clone().appendTo('.header .main_nav');
      });
  
      //Remove default mega menus if vertical menus are selected
      if ($('.dropdown_link--vertical').length){
        $('.dropdown_link--vertical.mega-menu-parent + .vertical-menu_submenu').remove();
        $('.dropdown_link--vertical:not(.mega-menu-parent)').each(function(index){
          var megaMenuValue = $(this).data('dropdown-rel');
          $('[data-dropdown="' + megaMenuValue + '"]').remove();
        })
      }
  
      $('.mega-menu-parent').on('mouseenter', function() {
  
        if(!$(this).hasClass('active_link')) {
          $('.dropdown_container').hide();
          $(this).parents('.main_nav').find('[data-dropdown="' + $(this).data('dropdown-rel') + '"]').toggle();
  
          $(this).addClass('active_link');
          $('.is-absolute').parent().removeClass('feature_image');
  
        }
      });
  
      //Remove theme-editor data-attributes
      header.removeDataAttributes('.header .mega-menu.dropdown_container .dropdown_column');
  
      if (is_touch_device() || $(window).width() <= 798) {
        $('.dropdown_link').attr('data-no-instant', true);
      }
  
      header.loadMobileMegaMenu();
    },
    loadMobileMegaMenu: function() {
  
      //Loop through mega menus and add to mobile menu
      $('.mega-menu-container .mobile-mega-menu').each(function(index){
        $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').find('span').remove();
        $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > a').append(' <span class="right icon-down-arrow"></span>').attr('data-no-instant', 'true');
        $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').addClass('mobile-mega-menu-parent sublink');
        $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').append(this);
        $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > ul').each(function(index){
          if (!$(this).hasClass('mobile-mega-menu')) {
            $(this).remove();
          }
        });
      });
    },
    unloadMegaMenu: function(){
      $('.header .mega-menu').remove();
      $('.mega-menu-container .mega-menu').each(function(index){
        var menuParent = $(this).data('dropdown');
        $('.mega-menu-parent[data-dropdown-rel="' + $(this).data("dropdown") + '"]').find('.icon-down-arrow').remove();
      });
    },
    unload: function() {
      $('body').off("click", '.mobile_nav');
      $('body').off('click', '.dropdown_link');
      $('html').off('click');
      $('.mini_cart').off('click');
      $('.cart_content__continue-shopping').off('click');
    }
}

header.loadMegaMenu();
header.init();